import { createContext, Dispatch, SetStateAction } from "react";

export const BackgroundContext = createContext<{ hideBackgroundImage: boolean; setHideBackgroundImage: Dispatch<SetStateAction<boolean>> }>(
  {
    hideBackgroundImage: false,
    setHideBackgroundImage(): void {},
  }
);
